<div class="loading" *ngIf="loadingLogo"><div class="loader"></div></div>

<div class="fake-body">
  <div class="main">
    <header class="header-bar animated fadeIn delay-1">
      <div class="container">
        <div class="practice-logo text-center">
          <a routerLink="/"
            ><img [src]="logo" width="200" alt="Client Hub"
          /></a>
        </div>
      </div>
    </header>

    @if (captchaPassed == false) {
      <ngx-turnstile
        style="display: flex; justify-content: center; margin-top: 30px"
        [siteKey]="env.captchaSiteKey"
        (resolved)="captchaResponse($event)"
        (errored)="captchaError($event)"
        theme="auto"
        [tabIndex]="0"
      ></ngx-turnstile>
    }

    @if (captchaPassed == true) {
      <div class="container text-center widgets animated fadeInUp delay-3">
        <div
          class="panel panel-default panel-login text-left"
          style="position: relative"
        >
          <div class="loading-overlay" *ngIf="isLoading">
            <div class="spinner"></div>
          </div>
          <div class="panel-heading">Login</div>
          <div class="panel-body">
            <form>
              <div class="form-group">
                <label for="inputEmail01">Email address</label>
                <input
                  [(ngModel)]="email"
                  id="inputEmail01"
                  [ngModelOptions]="{ standalone: true }"
                  type="email"
                  class="form-control"
                  placeholder="user@domain.com"
                  autofocus
                />
              </div>
              <div class="form-group">
                <label for="inputPw01">Password</label>
                <div class="input-password">
                  <input
                    [(ngModel)]="password"
                    id="inputPw01"
                    [ngModelOptions]="{ standalone: true }"
                    type="password"
                    class="form-control"
                    placeholder="Password"
                  />
                  <i class="feather eye-off"></i>
                </div>
                <br />
                <div
                  style="
                    display: flex;
                    align-items: center;
                    white-space: nowrap;
                  "
                >
                  <div>
                    <div class="checkbox">
                      <label>
                        <input
                          type="checkbox"
                          [(ngModel)]="remember"
                          [checked]="remember"
                          [ngModelOptions]="{ standalone: true }"
                        />
                        Remember me
                      </label>
                    </div>
                  </div>
                  <div class="text-right flex-grow">
                    <a
                      routerLink="/forgot-password"
                      style="padding: 5px; display: inline-block"
                      >Forgot password?</a
                    >
                  </div>
                </div>
              </div>
              <button
                (click)="login()"
                type="submit"
                name="submit"
                class="btn btn-success btn-block btn-lg"
              >
                Login
              </button>
            </form>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="container text-center animated fadeIn delay-5">
    <footer class="privacy-terms">
      <a routerLink="/terms-of-service">Terms of Service</a>
      <a routerLink="/privacy-policy" style="margin-right: 15px"
        >Privacy Policy</a
      >
      <a routerLink="/data-security">Data Security</a>
    </footer>
  </div>
</div>
